<ng-container *ngIf="projectData?.layerTree">
    <twc-accordion (toggle)="onToggle(layerData)" class="accordion-border twc-mb-3" *ngFor="let layerData of infoData">
        <twc-accordion-title class="twc-h5 twc-mb-0">
            {{layerData.title | translate}} ({{layerData?.data?.length }})
        </twc-accordion-title>
        <twc-accordion-content class="width-100 twc-mx-0" *ngIf="!isLayerTreeLoading(layerData?.data)">
            <twc-accordion class="layer-detail-container" *ngFor="let item of asLayers(layerData.data)">
                <twc-accordion-title class="twc-h5 twc-mb-0">{{item.name}}
                </twc-accordion-title> 
                <twc-accordion-content class="twc-ml-4">
                    <cw-horizontal-layer [layerData]="item">
                    </cw-horizontal-layer>
                </twc-accordion-content>
            </twc-accordion>
        </twc-accordion-content>
        <twc-accordion-content class="loader" *ngIf="isLayerTreeLoading(layerData?.data)">
            <twc-loader size="tiny"></twc-loader>
        </twc-accordion-content>
    </twc-accordion>
</ng-container>